module.exports = __webpack_public_path__ + "img/smokeDetector.58773fd3.png";